import React from 'react';
import "./DesignNavbar.css";
import { MdArrowDropDown } from 'react-icons/md';
import { FaCircleArrowLeft } from 'react-icons/fa6';

const DesignNavbar = () => {
    return (
        <header className="hearder-navbar-design">
            <div className="navbar-design">
                {/*section des logo */}
                <div className="">
                    <div className="card-image-design">
                        <img src="design/images/LOGO_Rezaplus.png" alt='logo' className="header-logo-image-design rounded" />
                    </div>
                </div>
                {/*section de lien de page en question */}
                <div className="container-navbar-element-design">
                    <div className="container-navbar-design-link-active">
                        <div>Explorer</div>
                    </div>
                    <div className="container-navbar-design-link">
                        <div>Qui somme nous ?</div>
                    </div>
                    <div className="container-navbar-design-link">
                        <div>Contact</div>
                    </div>
                    <div classNAme="container-navbar-design-button-parent ">
                        <div className="container-navbar-design-button">
                            <div>Compte</div>
                            <div>
                                <MdArrowDropDown className="text-primary" size={30} />
                            </div>
                        </div>
                        
                        <div className="container-navbar-design-button-card shadow bg-white">
                            <div className="py-1"><span><FaCircleArrowLeft className="text-primary" size={20} /> Se connecter</span></div>
                            <div className="py-1"><span className="font-bold" style={{ fontWeight:"600" }}>CRER UN COMPTE</span></div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default DesignNavbar;
